import { lazy } from 'react';
export const ResearchSlidesPage = lazy(() => import(/* webpackChunkName: "study-slides" */ '.'));
export default ResearchSlidesPage;
